import GenerateCode from "./GenerateCode";
import Referral from "./Referral";
import ExtInstallation from "./ExtInstallation";
import DesktopInstallation from "./DesktopInstallation";
import AppStoreRating from "./AppStoreRating";
import GooglePlayRating from "./GooglePlayRating";
import CapterraRating from "./CapterraRating";
import ClutchRating from "./ClutchRating";
import G2Rating from "./G2Rating";

const rewardComponents = {
  GenerateCode,
  Referral,
  ExtInstallation,
  DesktopInstallation,
  AppStoreRating,
  GooglePlayRating,
  CapterraRating,
  ClutchRating,
  G2Rating
}

export default rewardComponents